import React from 'react';
import { ServiceCard } from './ServiceCard';
const services = [{
  number: '1',
  title: 'Assistants',
  description: 'Conversational helpers that answer, guide, and retrieve—internally or customer-facing.',
  outcomes: 'Faster responses, reduced handle time, better self-service.',
  examples: 'Helpdesk triage, knowledge Q&A, onboarding concierge.'
}, {
  number: '2',
  title: 'Copilots',
  description: 'Context-aware copilots embedded in your tools to recommend next actions and automate routine steps.',
  outcomes: 'Higher throughput, fewer errors, happier teams.',
  examples: 'Sales email drafting in CRM, code review in IDE, finance close support.'
}, {
  number: '3',
  title: 'Autopilots',
  description: 'Goal-seeking automations that execute multi-step workflows with human-in-the-loop checkpoints.',
  outcomes: 'Shorter cycle times, consistent quality, lower operating costs.',
  examples: 'Lead qualification → meeting booking, invoice processing → payment.'
}, {
  number: '4',
  title: 'Agents',
  description: 'Autonomous, tool-using agents that plan, decide, and act across your stack—safely governed.',
  outcomes: 'End-to-end execution, 24/7 reliability, compounding learning.',
  examples: 'Catalog maintenance, supply reordering, marketing ops orchestration.'
}];
export function ServicesSection() {
  return <section id="services" className="py-24" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <h2 className="section-title" data-id="element-165">
          What We Deliver: The 4 Tiers of AI Value
        </h2>
        <p className="section-subtitle" data-id="element-166">
          Our services scale from simple assistance to full autonomy, matching
          the right AI solution to your specific business need.
        </p>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-167">
          {services.map(service => <ServiceCard key={service.number} {...service} data-id="element-168" />)}
        </div>
      </div>
    </section>;
}